import { useState, useRef, useEffect } from "react";

const MultiSelectCheckbox = ({
  id,
  options = [],
  value = [],
  onChange,
  placeholder = "Select options",
  error,
  focusedInput,
  setFocusedInput,
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleOption = (id) => {
    if (value?.includes(id)) {
      onChange(value?.filter((v) => v !== id));
    } else {
      onChange([...value, id]);
    }
  };

  // --- NEW: Helper function to get selected options for rendering ---
  const selectedOptions = options?.filter((opt) => value?.includes(opt?.id));
  // --- NEW: Function to render the selected tags ---
  const renderSelectedTags = () => (
    <div className="flex flex-wrap gap-2">
      {selectedOptions?.map((opt) => (
        <span
          key={opt?.id}
          // Tailwind classes for the background color, text color, padding, and rounded corners
          className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full"
        >
          {opt?.name}
        </span>
      ))}
    </div>
  );

  return (
    <>
      <div className="relative mt-4" ref={dropdownRef}>
        <div
          id={id}
          tabIndex={0}
          onFocus={() => setFocusedInput(id)}
          onBlur={() => setFocusedInput(null)}
          onClick={() => setOpen(!open)}
          className={`w-full border-2 text-sm cursor-pointer ${
            focusedInput === id
              ? "border-[#2BACE2] shadow-lg shadow-blue-100"
              : "border-gray-200"
          } rounded-lg px-4 py-3 bg-gray-50 transition-all min-h-[46px]`}
        >
          {/* --- MODIFIED RENDERING LOGIC HERE --- */}
          {value.length > 0 ? (
            renderSelectedTags()
          ) : (
            <span className="text-gray-400">{placeholder}</span>
          )}
        </div>

        {/* Dropdown */}
        {open && (
          <div className="absolute z-50 mt-2 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto">
            {options.map((option) => (
              <label
                key={option.id}
                className={`flex items-center px-4 py-2 
            ${
              option.disable
                ? "opacity-50 cursor-not-allowed"
                : "hover:bg-gray-100 cursor-pointer"
            }`}
              >
                <input
                  type="checkbox"
                  checked={value.includes(option.id)}
                  // Use 'disabled' property consistently
                  onChange={() => !option.disable && toggleOption(option.id)}
                  disabled={option.disable}
                  className="mr-3"
                />
                {option.name}
              </label>
            ))}
          </div>
        )}
      </div>

      {error && <div className="text-red-400 text-sm">{error}</div>}
    </>
  );
};

export default MultiSelectCheckbox;
